/**
 * @description 指标卡图表
 */
import React from 'react'
import { InformationCircleIcon } from '@heroicons/react/24/outline'

interface Props {
  icon?: string
  option: {
    dataset: {
      source: any[]
    }
  }
}

function formatNumber(val: string, ratio = 2) {
  // 使用正则表达式匹配数字模式（包括整数和带小数点的数字）
  const isNumber = /^-?\d+(\.\d+)?$/.test(val)
  if (isNumber) {
    const strNum = Number((+val).toFixed(ratio)) + ''
    // return num.replace(/\d(?=(\d{3})+\.)/g, '$&,')

    // 将整数部分和小数部分分开
    const parts = strNum.split('.')
    let integerPart = parts[0] || ''
    const decimalPart = parts[1] || ''

    // 对整数部分进行千分位格式化
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    // 返回格式化后的结果
    return decimalPart ? `${integerPart}.${decimalPart}` : integerPart
  } else {
    // 有的时候是字符串，比如用户问今天的日期，这个时候就是字符串，不做格式化
    if (val == null) {
      return (
        <div className="flex items-center gap-2">
          无数据
          <InformationCircleIcon className="h-6 w-6 text-yellow-300 dark:text-yellow-600" />
        </div>
      )
    } else {
      return val
    }
  }
}

function Kpi(props: Props) {
  const firstRow = props.option.dataset.source?.[0] || {}
  const [...kpiKeys] = Object.keys(firstRow)

  return (
    <div className="kpi flex flex-row justify-between">
      {kpiKeys.map((key, index) => (
        <div className="kpi-item flex items-center space-x-2" key={index}>
          <div className="text-left">
            <div className="kpi-value max-w-[12rem] truncate text-xl font-medium leading-9 text-slate-900 dark:text-slate-50">
              {formatNumber(firstRow[key])}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Kpi
